import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/home/page';
import RealEstate from './pages/real-estate/page';
import Commercial from './pages/commercial/page';
import SocialMedia from './pages/social-media/page';
import Reviews from './pages/reviews/page';
import Contact from './pages/contact/page';
import CancelPage from './pages/cancel/page';
import NotFound from './pages/NotFound';
import AnnouncementBanner from './components/AnnouncementBanner';

// Admin pages
import AdminLogin from './pages/admin/Login';
import AdminDashboard from './pages/admin/Dashboard';
import AdminBookings from './pages/admin/Bookings';
import AdminContacts from './pages/admin/Contacts';
import AdminReviews from './pages/admin/Reviews';
import AdminSettings from './pages/admin/Settings';
import AdminClients from './pages/admin/Clients';
import AdminCustomPackages from './pages/admin/CustomPackages';
import AdminBookForClient from './pages/admin/BookForClient';

// Client Portal pages
import PortalLogin from './pages/portal/Login';
import PortalAcceptInvite from './pages/portal/AcceptInvite';
import PortalDashboard from './pages/portal/Dashboard';
import PortalBookPackage from './pages/portal/BookPackage';

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AnnouncementBanner />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/real-estate" element={<RealEstate />} />
          <Route path="/commercial" element={<Commercial />} />
          <Route path="/social-media" element={<SocialMedia />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/cancel/:token" element={<CancelPage />} />

          {/* Client Portal Routes */}
          <Route path="/portal/login" element={<PortalLogin />} />
          <Route path="/portal/invite/:token" element={<PortalAcceptInvite />} />
          <Route path="/portal/dashboard" element={<PortalDashboard />} />
          <Route path="/portal/book/:assignmentId" element={<PortalBookPackage />} />

          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/bookings" element={<AdminBookings />} />
          <Route path="/admin/clients" element={<AdminClients />} />
          <Route path="/admin/clients/:clientId/book/:assignmentId" element={<AdminBookForClient />} />
          <Route path="/admin/custom-packages" element={<AdminCustomPackages />} />
          <Route path="/admin/contacts" element={<AdminContacts />} />
          <Route path="/admin/reviews" element={<AdminReviews />} />
          <Route path="/admin/settings" element={<AdminSettings />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
